import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const DeliveryContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px;
  min-height: 70vh;
`;

const Title = styled.h1`
  text-align: center;
  color: #333;
  margin-bottom: 20px;
  font-size: 2.5rem;
  font-weight: 700;
`;

const Subtitle = styled.p`
  text-align: center;
  color: #666;
  margin-bottom: 60px;
  font-size: 1.2rem;
  max-width: 800px;
  margin: 0 auto 60px;
`;

const Section = styled.div`
  margin-bottom: 60px;
`;

const SectionTitle = styled.h2`
  color: #4CAF50;
  margin-bottom: 30px;
  font-size: 2rem;
  font-weight: 600;
  text-align: center;
`;

const DeliveryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-top: 40px;
`;

const DeliveryCard = styled.div`
  background: #f8f9fa;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

const DeliveryIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #4CAF50, #45a049);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  margin: 0 auto 20px;
`;

const DeliveryTitle = styled.h3`
  color: #333;
  margin-bottom: 15px;
  font-size: 1.4rem;
  text-align: center;
`;

const DeliveryDescription = styled.p`
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
  text-align: center;
`;

const DeliveryInfo = styled.div`
  background: white;
  padding: 20px;
  border-radius: 10px;
  margin-top: 15px;
`;

const InfoItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  
  &:last-child {
    border-bottom: none;
  }
`;

const InfoLabel = styled.span`
  color: #555;
  font-weight: 500;
`;

const InfoValue = styled.span`
  color: #4CAF50;
  font-weight: 600;
`;

const PaymentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 40px;
`;

const PaymentCard = styled.div`
  background: #f8f9fa;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const PaymentIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #FF9800, #f57c00);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  margin: 0 auto 20px;
`;

const PaymentTitle = styled.h3`
  color: #333;
  margin-bottom: 15px;
  font-size: 1.4rem;
`;

const PaymentDescription = styled.p`
  color: #666;
  line-height: 1.6;
`;

const ImportantNote = styled.div`
  background: linear-gradient(135deg, #2196F3, #1976D2);
  color: white;
  padding: 30px;
  border-radius: 15px;
  text-align: center;
  margin-top: 40px;
`;

const NoteTitle = styled.h3`
  margin-bottom: 15px;
  font-size: 1.4rem;
`;

const NoteText = styled.p`
  line-height: 1.6;
  margin: 0;
`;

const ContactInfo = styled.div`
  background: #f8f9fa;
  padding: 30px;
  border-radius: 15px;
  text-align: center;
  margin-top: 40px;
`;

const ContactTitle = styled.h3`
  color: #333;
  margin-bottom: 20px;
  font-size: 1.4rem;
`;

const ContactItem = styled.div`
  margin-bottom: 15px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const ContactLabel = styled.span`
  color: #555;
  margin-right: 10px;
`;

const ContactValue = styled.span`
  color: #4CAF50;
  font-weight: 600;
`;

const Delivery = () => {
  const [warehousesList, setWarehousesList] = useState('Загрузка...');

  useEffect(() => {
    fetch('/api/delivery/pickup-points')
      .then(res => res.json())
      .then(result => {
        if (result.success && result.data?.length) {
          const list = result.data
            .map(w => (w.address ? `${w.name}: ${w.address}` : w.name))
            .join('; ');
          setWarehousesList(list || '—');
        } else {
          setWarehousesList('—');
        }
      })
      .catch(() => setWarehousesList('—'));
  }, []);

  return (
    <DeliveryContainer>
      <Title>Доставка и оплата</Title>
      <Subtitle>
        Удобные способы доставки и оплаты для вашего комфорта
      </Subtitle>

      <Section>
        <SectionTitle>Способы доставки</SectionTitle>
        
        <DeliveryGrid>
          <DeliveryCard>
            <DeliveryIcon>🏪</DeliveryIcon>
            <DeliveryTitle>Пункты выдачи (ПВЗ)</DeliveryTitle>
            <DeliveryDescription>
              Самовывоз из пунктов выдачи в Самаре и Новокуйбышевске
            </DeliveryDescription>
            <DeliveryInfo>
              <InfoItem>
                <InfoLabel>Самара</InfoLabel>
                <InfoValue>ПВЗ доступны</InfoValue>
              </InfoItem>
              <InfoItem>
                <InfoLabel>Новокуйбышевск</InfoLabel>
                <InfoValue>ПВЗ доступны</InfoValue>
              </InfoItem>
              <InfoItem>
                <InfoLabel>Стоимость</InfoLabel>
                <InfoValue>Бесплатно</InfoValue>
              </InfoItem>
            </DeliveryInfo>
          </DeliveryCard>

          <DeliveryCard>
            <DeliveryIcon>🚚</DeliveryIcon>
            <DeliveryTitle>Доставка СДЭК</DeliveryTitle>
            <DeliveryDescription>
              Курьерская доставка или пункт выдачи по всей России
            </DeliveryDescription>
            <DeliveryInfo>
              <InfoItem>
                <InfoLabel>Регионы</InfoLabel>
                <InfoValue>По всей РФ</InfoValue>
              </InfoItem>
              <InfoItem>
                <InfoLabel>Срок доставки</InfoLabel>
                <InfoValue>3-5 рабочих дней</InfoValue>
              </InfoItem>
              <InfoItem>
                <InfoLabel>Стоимость</InfoLabel>
                <InfoValue>Бесплатно от 10 000 ₽</InfoValue>
              </InfoItem>
            </DeliveryInfo>
          </DeliveryCard>

          <DeliveryCard>
            <DeliveryIcon>📦</DeliveryIcon>
            <DeliveryTitle>Доставка 5Post</DeliveryTitle>
            <DeliveryDescription>
              Доставка в пункты выдачи и постаматы Пятерочки по всей России
            </DeliveryDescription>
            <DeliveryInfo>
              <InfoItem>
                <InfoLabel>Регионы</InfoLabel>
                <InfoValue>По всей РФ</InfoValue>
              </InfoItem>
              <InfoItem>
                <InfoLabel>Срок доставки</InfoLabel>
                <InfoValue>3-7 рабочих дней</InfoValue>
              </InfoItem>
              <InfoItem>
                <InfoLabel>Стоимость</InfoLabel>
                <InfoValue>Бесплатно от 10 000 ₽</InfoValue>
              </InfoItem>
            </DeliveryInfo>
          </DeliveryCard>
        </DeliveryGrid>
      </Section>

      <Section>
        <SectionTitle>Способы оплаты</SectionTitle>
        
        <PaymentGrid>
          <PaymentCard>
            <PaymentIcon>💳</PaymentIcon>
            <PaymentTitle>Оплата банковской картой</PaymentTitle>
            <PaymentDescription>
              Безопасная оплата банковской картой через Робокассу. 
              Принимаются карты Visa, MasterCard, МИР.
            </PaymentDescription>
          </PaymentCard>

          <PaymentCard>
            <PaymentIcon>📱</PaymentIcon>
            <PaymentTitle>СБП (Система быстрых платежей)</PaymentTitle>
            <PaymentDescription>
              Оплата через СБП по QR-коду или номеру телефона. 
              Быстро и безопасно через ваш банк.
            </PaymentDescription>
          </PaymentCard>

          <PaymentCard>
            <PaymentIcon>💼</PaymentIcon>
            <PaymentTitle>Сплит-платеж</PaymentTitle>
            <PaymentDescription>
              Разделение оплаты на несколько частей или карт. 
              Удобно для крупных покупок.
            </PaymentDescription>
          </PaymentCard>
        </PaymentGrid>
      </Section>

      <ImportantNote>
        <NoteTitle>Важная информация</NoteTitle>
        <NoteText>
          Все цены указаны в рублях. Доставка рассчитывается индивидуально в зависимости от веса заказа и региона доставки. 
          Для уточнения стоимости доставки свяжитесь с нашими менеджерами.
        </NoteText>
      </ImportantNote>

      <ContactInfo>
        <ContactTitle>Контакты для уточнения информации</ContactTitle>
        <ContactItem>
          <ContactLabel>Телефон:</ContactLabel>
          <ContactValue>+7 917 120-58-58</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>Адреса складов:</ContactLabel>
          <ContactValue>
            Отрадный, Спортивная ул., д. 7<br/>
            Новокуйбышевск, ул. Горького 43 Б
          </ContactValue>
        </ContactItem>
      </ContactInfo>
    </DeliveryContainer>
  );
};

export default Delivery; 